import { Component, Input, Output, EventEmitter, Type } from '@angular/core';
import { ModalComponent } from './modal';
declare var require: any;

@Component({
    selector: 'modal-header',
    template: require('../template/modal-header.template.html'),
    styles: [require('../template/modal-header.css')],
    
})
export class ModalHeaderComponent {
    @Input('show-close') showClose: boolean = false;
    constructor(private modal: ModalComponent) { }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/modeldialog/Component/modal-header.ts